import InputCheckBox from '@/components/form-control/InputCheckBox'
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material'
import { Stack } from '@mui/system'
import { FC } from 'react'
import { useForm } from 'react-hook-form'

interface SitesTableProps {
  rows: {
    id: string
    location: string
  }[]
}

const SitesTable: FC<SitesTableProps> = ({ rows }) => {
  const form = useForm({
    defaultValues: {
      controller: '',
      station: '',
    },
  })

  return (
    <Stack flexGrow="1">
      <TableContainer
        component={Paper}
        elevation={0}
        sx={{
          backgroundColor: 'common.white',
          border: '1px solid #EFEFEF',
          borderRadius: '3px',
          '&::-webkit-scrollbar': {
            width: '8px',
            height: '8px',
          },

          '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#C1C1C1',
            borderRadius: '5px',
          },
        }}
      >
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead sx={{ backgroundColor: '#EFEFEF' }}>
            <TableRow>
              <TableCell
                sx={{
                  width: '29px',
                  backgroundColor: '#EFEFEF',
                  position: 'sticky',
                  left: 0,
                }}
              >
                #
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '182px',
                  borderRight: '1px solid #D7D7D7',
                  backgroundColor: '#EFEFEF',
                  position: 'sticky',
                  left: 0,
                }}
              >
                Location
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '102.27px',
                }}
              >
                S1C1
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '102.27px',
                }}
              >
                S1C2
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '102.27px',
                }}
              >
                S1C3
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '102.27px',
                }}
              >
                S1C4
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '102.27px',
                }}
              >
                S1C5
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '102.27px',
                }}
              >
                S1C6
              </TableCell>

              <TableCell
                sx={{
                  minWidth: '102.27px',
                }}
              >
                S1C7
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '102.27px',
                }}
              >
                S1C8
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '102.27px',
                }}
              >
                S1C9
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '102.27px',
                }}
              >
                S1C10
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '102.27px',
                }}
              >
                S1C11
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody sx={{ backgroundColor: 'common.white' }}>
            {rows.map((row) => (
              <TableRow key={row.id}>
                <TableCell
                  component="th"
                  scope="row"
                  sx={{
                    position: 'sticky',
                    left: 0,
                    backgroundColor: '#FFFFFF',
                  }}
                >
                  {row.id}
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: '1px solid #D7D7D7',
                    position: 'sticky',
                    left: 0,
                    backgroundColor: '#FFFFFF',
                  }}
                >
                  {row.location}
                </TableCell>
                <TableCell>
                  <InputCheckBox
                    form={form}
                    label=""
                    style={{
                      height: 0,
                      backgroundColor: 'common.white',
                      width: { xs: '100%' },
                      borderBottom: '0px',
                    }}
                    styleTypography={{
                      color: '#181818;',
                      fontWeight: 400,
                    }}
                  />
                </TableCell>
                <TableCell>
                  <InputCheckBox
                    form={form}
                    label=""
                    style={{
                      height: 0,
                      backgroundColor: 'common.white',
                      width: { xs: '100%' },
                      borderBottom: '0px',
                    }}
                    styleTypography={{
                      color: '#181818;',
                      fontWeight: 400,
                    }}
                  />
                </TableCell>
                <TableCell>
                  <InputCheckBox
                    form={form}
                    label=""
                    style={{
                      height: 0,
                      backgroundColor: 'common.white',
                      width: { xs: '100%' },
                      borderBottom: '0px',
                    }}
                    styleTypography={{
                      color: '#181818;',
                      fontWeight: 400,
                    }}
                  />
                </TableCell>
                <TableCell>
                  <InputCheckBox
                    form={form}
                    label=""
                    style={{
                      height: 0,
                      backgroundColor: 'common.white',
                      width: { xs: '100%' },
                      borderBottom: '0px',
                    }}
                    styleTypography={{
                      color: '#181818;',
                      fontWeight: 400,
                    }}
                  />
                </TableCell>
                <TableCell>
                  <InputCheckBox
                    form={form}
                    label=""
                    style={{
                      height: 0,
                      backgroundColor: 'common.white',
                      width: { xs: '100%' },
                      borderBottom: '0px',
                    }}
                    styleTypography={{
                      color: '#181818;',
                      fontWeight: 400,
                    }}
                  />
                </TableCell>
                <TableCell>
                  <InputCheckBox
                    form={form}
                    label=""
                    style={{
                      height: 0,
                      backgroundColor: 'common.white',
                      width: { xs: '100%' },
                      borderBottom: '0px',
                    }}
                    styleTypography={{
                      color: '#181818;',
                      fontWeight: 400,
                    }}
                  />
                </TableCell>
                <TableCell>
                  <InputCheckBox
                    form={form}
                    label=""
                    style={{
                      height: 0,
                      backgroundColor: 'common.white',
                      width: { xs: '100%' },
                      borderBottom: '0px',
                    }}
                    styleTypography={{
                      color: '#181818;',
                      fontWeight: 400,
                    }}
                  />
                </TableCell>
                <TableCell>
                  <InputCheckBox
                    form={form}
                    label=""
                    style={{
                      height: 0,
                      backgroundColor: 'common.white',
                      width: { xs: '100%' },
                      borderBottom: '0px',
                    }}
                    styleTypography={{
                      color: '#181818;',
                      fontWeight: 400,
                    }}
                  />
                </TableCell>
                <TableCell>
                  <InputCheckBox
                    form={form}
                    label=""
                    style={{
                      height: 0,
                      backgroundColor: 'common.white',
                      width: { xs: '100%' },
                      borderBottom: '0px',
                    }}
                    styleTypography={{
                      color: '#181818;',
                      fontWeight: 400,
                    }}
                  />
                </TableCell>
                <TableCell>
                  <InputCheckBox
                    form={form}
                    label=""
                    style={{
                      height: 0,
                      backgroundColor: 'common.white',
                      width: { xs: '100%' },
                      borderBottom: '0px',
                    }}
                    styleTypography={{
                      color: '#181818;',
                      fontWeight: 400,
                    }}
                  />
                </TableCell>
                <TableCell>
                  <InputCheckBox
                    form={form}
                    label=""
                    style={{
                      height: 0,
                      backgroundColor: 'common.white',
                      width: { xs: '100%' },
                      borderBottom: '0px',
                    }}
                    styleTypography={{
                      color: '#181818;',
                      fontWeight: 400,
                    }}
                  />
                </TableCell>

              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

    </Stack>
  )
}

export default SitesTable
